import axios from "axios";
import { useState, useEffect } from "react";

const useEventsData = () => {
  const [eventData, setEventData] = useState([]);

  useEffect(() => {
    axios
      .get("https://fakestoreapi.com/products")
      .then((res) => setEventData(res.data));
  }, []);

  return [eventData, setEventData];
};

export default useEventsData;
